import { createSlice } from '@reduxjs/toolkit';
import { FtpLogListApi, LithosFtpLogListApi } from '../services/api';

export const LithosFtpLogSlice = createSlice({
	name: 'LithosFtpLog',
	initialState: {
		isLoading: false,
		ftpLogList: [],
		error: null,
	},
	reducers: {
		setLoading: (state) => {
			state.isLoading = true;
		},

		ftpLogData: (state, action) => {
			state.isLoading = false;
			state.ftpLogList = action.payload;
		},

		ftpLogErrorList: (state, action) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const { ftpLogData, setLoading, ftpLogErrorList } = LithosFtpLogSlice.actions;

export default LithosFtpLogSlice.reducer;

export const LithosFtpLogListRequest = (queryString) => async (dispatch, getState) => {
	dispatch(setLoading());
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: getState()?.auth?.Token,
			},
		};
		const { data } = await LithosFtpLogListApi(queryString, config);

		dispatch(ftpLogData(data));
		console.log(data, "data")
	} catch (error) {
		dispatch(ftpLogErrorList(error));
	}
};
